import { Inject } from '@angular/core';
import { CourseTableLabels } from '../models/types';
import { BasePriceListBandsService } from './base-pricelist-bands.service';
import { JuniorPriceListPackage } from '../models';

@Inject({
  providedIn: 'root',
})
export class JuniorCampsPackagesBandsService extends BasePriceListBandsService<JuniorPriceListPackage> {
  /**
   * Returns the column labels for the junior camps packages table.
   * Example:
   * [
   *   { duration: '1-1', header: '1 week' },
   *   { duration: '2-2', header: '2 weeks'},
   *   { duration: '', header: '+ week' },
   * ]
   */
  getColumnLabels(courses: JuniorPriceListPackage[]): CourseTableLabels {
    const bands = this.getSortedBands(courses);
    const headerColumns = this.getHeaderColumnsWithBands(bands, {
      singular: 'week',
      plural: 'weeks',
    });

    return {
      title: 'Courses',
      weeks: headerColumns,
    };
  }
}
